import i18n from 'i18next';
import detector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';

import en from './locales/en/defaults.json';
import jp from './locales/jp/defaults.json';
import zh from './locales/zh/defaults.json';

declare global {
  interface Window {
    i18n: any;
  }
}

const resources = {
  en: {
    translation: en,
  },
  jp: {
    translation: jp,
  },
  zh: {
    translation: zh,
  },
};

i18n
  .use(detector)
  .use(initReactI18next)
  .init({
    resources,
    lng: getCurrentLanguage(),
    fallbackLng: getCurrentLanguage(),
    nsSeparator: false,
    detection: {
      order: ['querystring', 'cookie', 'localStorage', 'navigator', 'htmlTag'],
      lookupQuerystring: 'lang',
      lookupCookie: 'i18n',
      lookupLocalStorage: 'language',
      caches: ['localStorage', 'cookie'],
    },
    interpolation: { escapeValue: false },
  });

export default i18n;

if (typeof window !== 'undefined') {
  window.i18n = i18n;
}

export function getCurrentLanguage() {
  return localStorage.getItem('language') || 'jp';
}
